import script from "./IphoneMockup.vue?vue&type=script&setup=true&lang=js"
export * from "./IphoneMockup.vue?vue&type=script&setup=true&lang=js"

import "./IphoneMockup.vue?vue&type=style&index=0&id=6dc85d1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc85d1a"]])

export default __exports__